// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__3pBGm","theme-light":"style_theme-light__208xw","theme-dark":"style_theme-dark__bc4zU"};